module.exports = __webpack_public_path__ + "img/clock-eight-thirty.ea443745.svg";